import { render, staticRenderFns } from "./ClientsDetailsAdmin.vue?vue&type=template&id=7c8917be&scoped=true&"
import script from "./ClientsDetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientsDetailsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDetailsAdmin.vue?vue&type=style&index=0&id=7c8917be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8917be",
  null
  
)

export default component.exports